/**
 * @file Contains all keys used for the theme values saved in the global settings.
 */

export const primaryColorLightGlobalSettingsKey = import.meta.env
    .VITE_GLOBAL_SETTINGS_PRIMARY_COLOR_LIGHT_KEY
export const secondaryColorLightGlobalSettingsKey = import.meta.env
    .VITE_GLOBAL_SETTINGS_SECONDARY_COLOR_LIGHT_KEY
export const primaryColorDarkGlobalSettingsKey = import.meta.env
    .VITE_GLOBAL_SETTINGS_PRIMARY_COLOR_DARK_KEY
export const secondaryColorDarkGlobalSettingsKey = import.meta.env
    .VITE_GLOBAL_SETTINGS_SECONDARY_COLOR_DARK_KEY

export const logoGlobalSettingsKey = import.meta.env
    .VITE_GLOBAL_SETTINGS_LOGO_KEY
